/**
 * Persists Sentry breadcrumbs across full page loads so the user's journey on
 * regular WordPress pages (init-sentry.js) can be replayed onto errors captured
 * on the standalone ng-checkout SPA page (ng-checkout-error-listener.js).
 */
const STORAGE_KEY = 'sentry_journey_breadcrumbs';

// Sentry caps an event at 100 breadcrumbs total. Keep limit under that so the checkout page's
// own breadcrumbs aren't crowded out.
const MAX_JOURNEY_BREADCRUMBS = 50;

/**
 * Append a breadcrumb to the persisted, capped ring buffer.
 * Failures are swallowed so they never block the breadcrumb itself.
 */
export function persistJourneyBreadcrumb(breadcrumb) {
  if (!breadcrumb) {
    return;
  }

  try {
    const stored = readJourneyBreadcrumbs();
    stored.push(breadcrumb);
    const trimmed = stored.slice(-MAX_JOURNEY_BREADCRUMBS);
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed));
  } catch {
    // sessionStorage unavailable, full, or breadcrumb not serializable — skip it.
  }
}

/**
 * Read the persisted journey breadcrumbs. Returns [] as fallback.
 */
export function readJourneyBreadcrumbs() {
  try {
    const parsed = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '[]');

    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}
